import axios from "axios";

export function getProductDetailData({
  product_uuid,
  branch_uuid,
  country,
  city_id,
  period,
  start_date,
  end_date,
  url
}) {
  let city = city_id;
  return new Promise((resolve, reject) => {
    axios
      .post(url, {
        country,
        city,
        product_uuid,
        branch_uuid,
        period,
        start_date,
        end_date
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        if (error?.response?.data) {
          reject(error.response.data);
        } else {
          reject(error);
        }
      });
  });
}

export default getProductDetailData;
